import { render } from "./App.vue?vue&type=template&id=356cb43b&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=356cb43b&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__